module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dropdown"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown",
      "data-target": '.dropdownFilterTags' + _vm.index
    }
  }, [_vm._v(_vm._s(_vm.dropdown_title)), _c('span', {
    staticClass: "gray-bold-caret"
  }), _c('filter-tags-autocomplete', {
    staticClass: "dropdownFilterTags",
    class: 'dropdownFilterTags' + _vm.index,
    attrs: {
      "id": "dropdownFilterTags",
      "filter_item_selected_ids": _vm.filter_item_selected_ids,
      "uncheck_all_items": _vm.uncheck_all_items
    },
    on: {
      "item-selected-items": _vm.itemSelectedItems
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b929118e!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/shared/dropdown_multiple_kind/tag_filter.vue
// module id = 1206
// module chunks = 1